/* import __COLOCATED_TEMPLATE__ from './share-popup.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type IntlService from 'ember-intl/services/intl';

interface SharePopupSignature {
  Element: HTMLDivElement;
  Args: {
    nonDDSQueryString: string;
    close: () => void;
  };
}
export default class SharePopup extends Component<SharePopupSignature> {
  @service declare intl: IntlService;

  get shareLink() {
    return window.location.href;
  }
  @tracked isCopiedDisplayed = false;

  get communityURL() {
    return this.intl.t('share.dds_forum_link').toString() + this.args.nonDDSQueryString;
  }

  @action copyToClipboard() {
    const textArea = document.createElement('textarea');

    textArea.style.background = 'transparent';
    textArea.value = this.shareLink;
    document.getElementById('clipboardArea')?.appendChild(textArea);

    textArea.select();
    let result = false;
    try {
      if (document.queryCommandSupported('copy')) {
        result = document.execCommand('copy');
      }
    } catch (err) {
      result = false;
    }

    document.getElementById('clipboardArea')?.removeChild(textArea);

    this.isCopiedDisplayed = result;
  }
}
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    SharePopup: typeof SharePopup;
  }
}
